export const APPLICANT_TYPES = {
  parent: 'PARENT',
  participant: 'PARTICIPANT'
};

export const MAIN_DATA_CHILD = 'MAIN_DATA_CHILD';
